import React, { useState, useCallback, useEffect } from "react";
import axios from "axios";
import HttpAction from "modules/utils/HttpAction";
import ErroCode from "modules/utils/ErrorCode";

const OperationContext = React.createContext({
  state: { operationList: {}, operation: {} },
  actions: {
    getOperation: () => {},
    getOperationList: () => {},
  },
});

const OperationProvider = ({ children }) => {
  const [operation, setOperation] = useState({});
  const [operationList, setOperationList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);

  const getOperationList = (pageInfo) => {
    HttpAction({
      url: "api/admin/operation/list",
      method: "get",
      params: {
        searchName: pageInfo && pageInfo.searchName,
      },
    }).then((res) => {
      if (res.code === 200) {
        setOperationList({ data: res.data, sortFlg: res.sortFlg });
      } else {
      }
    });
  };

  const getOperation = (operationDeptId) => {
    HttpAction({
      url: "api/admin/operation",
      method: "get",
      params: {
        operationDeptId: operationDeptId,
      },
    }).then((res) => {
      if (res.code === 200) {
        setOperation(res.data);
      } else {
      }
    });
  };

  const getDepartmentList = (searchName) => {
    HttpAction({
      url: "api/admin/operation/list",
      method: "get",
      params: {
        searchName: searchName,
      },
    }).then((res) => {
      if (res.code === 200) {
        setDepartmentList(res.data);
      } else {
      }
    });
  };

  const createOperation = useCallback(async (operationData, setState) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL;
    await axios
      .post(`api/admin/operation/save`, operationData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          Language: process.env.REACT_APP_LANGUAGE,
        },
      })
      .then((res) => {
        if (res.data.code === 200) {
          setState({
            type: "SAVE",
            state: true,
          });
          getOperationList({});
        } else {
          ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
        }
      });
  }, []);

  const updateOperation = useCallback(async (operationData, setState) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL;
    await axios
      .post(`api/admin/operation/modify`, operationData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          Language: process.env.REACT_APP_LANGUAGE,
        },
      })
      .then((res) => {
        if (res.data.code === 200) {
          setState({
            type: "SAVE",
            state: true,
          });
          getOperationList({});
        } else {
          ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
        }
      });
  }, []);

  const updateOperationSort = useCallback((id, type) => {
    HttpAction({
      url: "api/admin/operation/list-swap",
      method: "post",
      data: {
        changeTargetId: id,
        swapType: type,
      },
    }).then((res) => {
      if (res.code === 200) {
        getOperationList({});
      } else {
        if (res.code === 401 && type === "UP")
          alert("이 등록자는 이미 최상단에 ​위치하고 있습니다.");
        if (res.code === 401 && type === "DOWN")
          alert("이 등록자는 이미 최하단에 ​위치하고 있습니다.");
      }
    });
  }, []);

  const deleteOperation = useCallback((operationDeptId, history, url) => {
    HttpAction({
      url: "api/admin/operation",
      method: "delete",
      params: {
        operationDeptId: operationDeptId,
      },
    }).then((res) => {
      if (res.code === 200) {
        getOperationList();
        history.push(url);
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const value = {
    state: { operation, operationList, departmentList },
    actions: {
      getOperationList,
      getOperation,
      createOperation,
      updateOperation,
      updateOperationSort,
      deleteOperation,
      getDepartmentList
    },
  };

  return (
    <OperationContext.Provider value={value}>
      {children}
    </OperationContext.Provider>
  );
};

const { Consumer: OperationConsumer } = OperationContext;

export { OperationProvider, OperationConsumer, OperationContext };

export default OperationContext;
